module.exports = __webpack_public_path__ + "static/img/threePhase_item_image4.c4aa641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/threePhase_item_image4.png
// module id = a4B5
// module chunks = 1